import {IResourceComponentsProps, useExport, useTranslate} from '@refinedev/core';

import {
    DateField, DeleteButton,
    List, ShowButton, TagField, useSelect,
    useTable,
} from '@refinedev/antd';

// It is recommended to use explicit import as seen below to reduce bundle size.
// import { IconName } from "@ant-design/icons";

import {Button, Col, DatePicker, Form, Input, Row, Select, Space, Table, Tag, Radio, Typography} from 'antd';
import React, {useContext, useEffect, useRef, useState} from 'react';
import {StoreContext} from '../../contexts/StoreContext';
import {IStock} from '../../interfaces';
import dayjs from 'dayjs';
import * as Icons from '@ant-design/icons';
import {CSVLink} from 'react-csv';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const { Title } = Typography;

export const ReportTurniList: React.FC<IResourceComponentsProps> = () => {
    const translate = useTranslate();
    const {value, value2, value4} = useContext(StoreContext);
    const [store, setStore] = value;
    const [espositore, setEspositore] = value4;
    const [datiGev, setDatiGev] = useState<any>([]);
    const tipo = useRef<any>();
    const dataIn = useRef<any>();
    const dataOut = useRef<any>();

    const { tableProps, tableQueryResult, searchFormProps, setFilters} = useTable<any>({
        resource: "turns",
        meta: {
          populate: '*'
        },
        syncWithLocation: false,
        queryOptions: {
            enabled: false
        },
        filters: {
            permanent: [
                {
                    field: 'seller][id]',
                    operator: 'eq',
                    value: store.id
                }
            ]
        },
        sorters: {
            initial: [
                {
                    field: "id",
                    order: "desc",
                },
            ],
        },
        pagination: {
            mode: "server",
            pageSize: 99999999
        }
    });

    const [showTable, setShowTable] = useState(false);
    const [dati, setDati] = useState<any>([]);


    const load = (e: any) => {
        setFilters([]);
        let arrA: any = [];
        let arrV: any = [];
        const dIn = new Date(searchFormProps.form?.getFieldValue('dataIn'));
        const dOut = new Date(searchFormProps.form?.getFieldValue('dataOut'));
        dIn.setHours(0,0,0,0);
        dOut.setHours(0,0,0,0);
        dataIn.current = dayjs(dIn).format('YYYY-MM-DD');
        dataOut.current = dayjs(dOut).format('YYYY-MM-DD');
        tipo.current = e;
        setFilters([{
            field: 'dataIn',
            operator: 'gte',
            value: dataIn.current
        },
            {
                field: 'dataOut',
                operator: 'lte',
                value: dataOut.current
            }])
        setTimeout(() => {
            getDati();
        }, 800)

    }

    const [dataExport, setDataExport] = useState<any>([]);

    const exportDati = () => {
        setDataExport(datiGev);
    }

    const estraiDatiPerTipo = (arrayTurni: any, tipo: 'T' | 'G' | 'A') => {
        const mappa: any = {
            T: {
                giacenza: 'giacenzaT',
                finale: 'valoreFinaleT',
                riassortimento: 'valoreRiassortimentoT',
                inventario: 'inventarioT',
                scompenso: 'scompensoT',
                keyIn: 'tabacchi',
                label: 'T',
            },
            G: {
                giacenza: 'giacenzaG',
                finale: 'valoreFinaleG',
                riassortimento: 'valoreRiassortimentoG',
                inventario: 'inventarioG',
                scompenso: 'scompensoG',
                keyIn: 'gev',
                label: 'G',
            },
            A: {
                giacenza: 'giacenzaA',
                finale: 'valoreFinaleA',
                riassortimento: 'valoreRiassortimentoA',
                inventario: 'inventarioA',
                scompenso: 'scompensoA',
                keyIn: 'acs',
                label: 'A',
            },
        };

        const config = mappa[tipo];
        if (!config) throw new Error(`Tipo non valido: ${tipo}`);

        return arrayTurni.map((turno: any) => {
            return {
                id: turno.id,
                dataOut: turno.dataOut,
                isConfirmed: turno.isConfirmed,
                [`giacenza`]: turno[config.giacenza] ?? 0,
                [`valoreRiassortimento`]: turno[config.riassortimento] ?? 0,
                [`inventario`]: turno[config.inventario] ?? 0,
                [`valoreFinale`]: turno[config.finale] ?? 0,
                [`scompenso`]: turno[config.scompenso] ?? 0,
                [`venduto`]: turno?.dati?.in?.[config.keyIn] ?? 0,
            };
        });
    }

    const getDati = () => {
        // searchFormProps.form?.submit();
        tableQueryResult.refetch().then((res) => {
            setDati(estraiDatiPerTipo(res?.data?.data, tipo.current));
            setShowTable(true);
        })
    }

    // useEffect(() => {
    //     if (tipo && tableQueryResult && tableQueryResult.data && tableQueryResult.data.data) {
    //         console.log(tableQueryResult);
    //         setDati(estraiDatiPerTipo(tableQueryResult?.data?.data, tipo));
    //         console.log(dati);
    //         //setDati(tableQueryResult?.data?.data);
    //     }
    // }, [tableQueryResult]);

    const generaExcel = (dati: any) => {
        const datiExcel = [];

        // Aggiunge una riga di intestazione con il titolo
        datiExcel.push([`Report Turni dal ${dati.dataIn} al ${dati.dataOut}`]);
        datiExcel.push([]); // Riga vuota per separazione

        // Funzione per aggiungere una sezione
        const aggiungiSezione = (nomeSezione: any, dati: any) => {
            if (!dati || Object.keys(dati).length === 0) return;

            datiExcel.push([nomeSezione]); // Titolo della sezione
            datiExcel.push(["Descrizione", "Importo"]); // Intestazione

            Object.entries(dati).forEach(([key, value]) => {
                datiExcel.push([key, value]); // Aggiunge le righe
            });

            datiExcel.push([]); // Riga vuota per separazione
        };

        // Aggiunge tutte le sezioni
        aggiungiSezione("Entrate", {...dati.datiTurni.top, ...dati.datiTurni.entrate});
        aggiungiSezione("Uscite", dati.datiTurni.exit);
        aggiungiSezione("Contabile", dati.datiTurni.contabile);

        // Creazione del foglio Excel
        const ws = XLSX.utils.aoa_to_sheet(datiExcel);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Report");
        // Salva il file con il titolo del report
        const nomeFile = `Export_Turni_dal_${dati.dataIn}_al_${dati.dataOut}.xlsx`;
        XLSX.writeFile(wb, nomeFile);
    };

    return (
            <List title={'Report Turni'}>
                <Form {...searchFormProps} layout="horizontal">
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item name={'dataIn'}>
                            <DatePicker
                                style={{width: '100%'}}
                                format={'DD-MM-YYYY'}
                                placeholder={'Dal...'}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'dataOut'}>
                            <DatePicker
                                style={{width: '100%'}}
                                format={'DD-MM-YYYY'}
                                placeholder={'al...'}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Radio.Group
                            name="radiogroup"
                            onChange={(e: any) => load(e.target.value)}
                            options={[
                                { value: "T", label: 'Tabacchi' },
                                { value: "G", label: 'G & V' },
                                { value: "A", label: 'Accessori' }
                            ]}
                        />
                    </Col>

                    {/*<Col span={4}>*/}
                    {/*    <Button type={'primary'} style={{width: '100%'}} onClick={confirm}>Conferma</Button>*/}
                    {/*</Col>*/}
                    {/*<Col span={4}>*/}
                    {/*        <Button type={'default'} style={{width: '100%'}} icon={<Icons.ExportOutlined />} onClick={() => generaExcel(dati)}>Export</Button>*/}
                    {/*</Col>*/}
                </Row>
                </Form>
                <hr />
                <>
                    <div hidden={!showTable}>
                        <>
                            <Table size="small" dataSource={dati} rowKey="id"
                                   onRow={(record) => {
                                       return {
                                           onClick: () => {
                                               // console.log("turn", record);
                                           },
                                       };
                                   }}
                                   sticky={true}
                                // scroll={{y: window.innerHeight - 293 + 'px'}}
                                   rowClassName={(record: any, index) => (record.isConfirmed ? "green" : "red")}
                            >
                                {/*<Table.Column dataIndex="id" key="id" title="ID"/>*/}
                                {/*<Table.Column*/}
                                {/*    dataIndex="user"*/}
                                {/*    key="user"*/}
                                {/*    title={translate('pages.category.user', 'Utente')}*/}
                                {/*    responsive={['xs', 'md', 'lg', 'xl']}*/}
                                {/*    render={(value, record) => {*/}
                                {/*        // <TagField value={value.name + ' ' + value.surname} />*/}
                                {/*        return (<>*/}
                                {/*            <TagField value={record?.user?.name + ' ' + record?.user?.surname} />*/}
                                {/*        </>)*/}
                                {/*    }*/}
                                {/*    }*/}
                                {/*/>*/}
                                <Table.Column
                                    dataIndex="dataOut"
                                    key="dataOut"
                                    title={translate('pages.category.dataOut', 'Data Chiusura')}
                                    sorter={(a: any, b: any) => {
                                        return(new Date(a.dataOut).getTime() - new Date(b.dataOut).getTime())}}
                                    responsive={['md', 'lg', 'xl']}
                                    render={(value) => <DateField value={value} format={'DD-MM-YYYY HH:mm'} />}
                                />
                                <Table.Column
                                    dataIndex="tipo"
                                    key="tipo"
                                    title={translate('pages.category.dataOut', 'Tipologia')}
                                    responsive={['md', 'lg', 'xl']}
                                    render={(value) => <TagField value={tipo.current == 'T' ? 'Tabacchi' : tipo.current == 'G' ? 'G&V' : 'Accessori'} />}
                                />
                                <Table.Column
                                    dataIndex="giacenza"
                                    key="giacenza"
                                    title={translate('pages.category.dataIn', 'Giacenza Iniziale')}
                                    responsive={['md', 'lg', 'xl']}
                                    render={(value, record) => <TagField value={'€ ' + Number(parseFloat(value)).toLocaleString('de', { minimumFractionDigits: 2 })}  />}
                                />
                                <Table.Column
                                    dataIndex="valoreRiassortimento"
                                    key="valoreRiassortimento"
                                    title={translate('pages.category.dataIn', 'Riassortimento')}
                                    responsive={['md', 'lg', 'xl']}
                                    render={(value, record) => <TagField value={'€ ' + Number(parseFloat(value)).toLocaleString('de', { minimumFractionDigits: 2 })}  />}
                                />
                                <Table.Column
                                    dataIndex="venduto"
                                    key="venduto"
                                    title={translate('pages.category.venduto', 'Venduto')}
                                    responsive={['md', 'lg', 'xl']}
                                    render={(value, record) => <TagField value={'€ ' + Number(parseFloat(value)).toLocaleString('de', { minimumFractionDigits: 2 })}  />}
                                />
                                <Table.Column
                                    dataIndex="valoreFinale"
                                    key="valoreFinale"
                                    title={translate('pages.category.venduto', 'Giacenza Finale')}
                                    responsive={['md', 'lg', 'xl']}
                                    render={(value, record) => <TagField value={'€ ' + Number(parseFloat(value)).toLocaleString('de', { minimumFractionDigits: 2 })}  />}
                                />
                                <Table.Column
                                    dataIndex="inventario"
                                    key="inventario"
                                    title={translate('pages.category.inventario', 'Inventario')}
                                    responsive={['md', 'lg', 'xl']}
                                    render={(value, record) => <TagField value={'€ ' + Number(parseFloat(value)).toLocaleString('de', { minimumFractionDigits: 2 })}  />}
                                />
                                <Table.Column
                                    dataIndex="scompenso"
                                    key="scompenso"
                                    title={translate('pages.category.venduto', 'Scompenso')}
                                    responsive={['md', 'lg', 'xl']}
                                    render={(value, record) => <TagField color={'red'} value={'€ ' + Number(parseFloat(record.inventario) - parseFloat(record.valoreFinale)).toLocaleString('de', { minimumFractionDigits: 2 })}  />}
                                />
                                <Table.Column<{ id: string }>
                                    title={translate('pages.docType.action', 'Verifica')}
                                    dataIndex="actions"
                                    responsive={['md', 'lg', 'xl']}
                                    key="actions"
                                    render={(value, record: any) => {

                                        const isAlert =  record.valoreFinale > record.giacenza;
                                        const differenza = record.valoreFinale - record.giacenza;

                                        return isAlert ? (
                                            <Tag color="red">
                                                ALERT (+€ {differenza.toLocaleString('de', { minimumFractionDigits: 2 })})
                                            </Tag>
                                        ) : (
                                            <Tag color="green">REGOLARE</Tag>
                                        );
                                    }}
                                />
                            </Table>
                        </>
                    </div>
                </>
            </List>
    );
};
